import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Sobre from './components/Sobre';
import Servicos from './components/Servicos';
import Portfolio from './components/Portfolio';
import CtaFinal from './components/CtaFinal';
import Contato from './components/Contato';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="font-montserrat">
      <Navbar />
      <Hero />
      <Sobre />
      <Servicos />
      <Portfolio />
      <CtaFinal />
      <Contato />
      <Footer />
    </main>
  );
}
